import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { Popup } from '../../../../components/Popup'
import { Button, BUTTON_TYPES } from '../../../../components/Button'
import { Typography } from '../../../../components/Typography'
import { setLoading } from '../../../../redux/store/common/slice'
import { useContractCategoryDetailsContext } from '../../Providers/ContractCategoryDetailsContextProvider'
import { useContractCategoryDetailsPopup } from '../../Providers/ContractCategoryDetailsPopupProvider'
import { deleteCCHS } from './api'
import { BTN_TXT, TOOLTIP } from '../../../../constants'
import { ReactComponent as Delete16 } from 'assets/svg/Delete16.svg'
import { DeleteHealthSystemPopupProps } from './types'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'

export const DeleteHealthSystemPopup = ({
  updateHSList,
  selectedHS,
  disableButton
}: DeleteHealthSystemPopupProps) => {
  const { deleteHealthSystemsPopup } = useContractCategoryDetailsPopup()
  const { state, actions } = deleteHealthSystemsPopup
  const { open: openDeletePopup, close: closeDeletePopup } = actions
  const { visible } = state
  const { state: stateContract } = useContractCategoryDetailsContext()
  const { details } = stateContract
  const dispatch = useDispatch()

  const handleDeleteUsers = useCallback(async () => {
    if (!details.uuid) {
      throw new Error('PRS ID not provided')
    }
    try {
      dispatch(setLoading(true))
      await deleteCCHS(
        details.uuid,
        {
          health_systems: selectedHS
            .filter((i) => !i.hospital_level)
            .map((i) => i.uuid),
          hospitals: selectedHS
            .filter((i) => i.hospital_level)
            .map((i) => i.uuid)
        },
        `${selectedHS.length > 1 ? 'Facilities' : 'Facility'} ${
          selectedHS.length > 1 ? 'have' : 'has'
        } been successfully deleted.`
      )
      updateHSList()
      closeDeletePopup()
    } finally {
      dispatch(setLoading(false))
    }
  }, [details, dispatch, updateHSList, selectedHS, closeDeletePopup])

  return (
    <>
      {!!selectedHS.length && (
        <Tooltip title={disableButton ? TOOLTIP.DISABLE_DELETE_HS : null}>
          <div>
            <Button
              type={BUTTON_TYPES.PRIMARY}
              onClick={openDeletePopup}
              icon={<Delete16 />}
              disabled={disableButton}
              upperCase
              danger
            >
              {BTN_TXT.DELETE}
            </Button>
          </div>
        </Tooltip>
      )}
      <Popup
        visible={visible}
        onCancel={closeDeletePopup}
        title={`Delete ${selectedHS.length === 1 ? 'Facility' : 'Facilities'}?`}
        width={442}
        footer={
          <>
            <Button
              type={BUTTON_TYPES.DEFAULT}
              onClick={closeDeletePopup}
              upperCase
            >
              {BTN_TXT.CANCEL}
            </Button>
            <Button
              type={BUTTON_TYPES.PRIMARY}
              onClick={handleDeleteUsers}
              upperCase
              danger
            >
              {BTN_TXT.DELETE}
            </Button>
          </>
        }
      >
        <Typography.Body1>
          {selectedHS.length === 1
            ? `Facility`
            : `${selectedHS.length} Facilities`}{' '}
          will be removed from all contracts within the{' '}
          {details.contract_category_name} Contract category.
        </Typography.Body1>
      </Popup>
    </>
  )
}
